import { render, staticRenderFns } from "./privateAgreement.vue?vue&type=template&id=7603dec1&scoped=true&"
import script from "./privateAgreement.vue?vue&type=script&lang=js&"
export * from "./privateAgreement.vue?vue&type=script&lang=js&"
import style0 from "./privateAgreement.vue?vue&type=style&index=0&id=7603dec1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7603dec1",
  null
  
)

export default component.exports